const ViewSinglePost = () => {
  return <h1>You are viewing a single post</h1>;
};

export default ViewSinglePost;
